import { Button, InputNumber, Popover, Typography, Flex } from "antd";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";

const SetQuantity = ({ handleSetSeriesQuantity }) => {
  const [quantity, setQuantity] = useState(1);
  const { formatMessage } = useIntl();

  const handleChangeQuantity = (value) => setQuantity(value);

  useEffect(() => {
    handleSetSeriesQuantity(quantity);
  }, [quantity]);

  return (
    <Flex vertical align="center">
      <Typography.Title level={5}>
        How many Series do you want to create with this configuration?
      </Typography.Title>
      <Flex justify="center">
        <InputNumber value={quantity} onChange={handleChangeQuantity} min={1} />
        <Popover
          trigger="click"
          content={formatMessage({
            id: "form.help.series.create.many",
            defaultMessage: "Create more than one series at a time",
          })}
        >
          <Button type="text" outline color="danger" size="sm">
            <i className="fas fa-circle-question" />
          </Button>
        </Popover>
      </Flex>
    </Flex>
  );
};

export default SetQuantity;
